import { themes } from '@olist/design-system-tokens';
import styled from 'styled-components';

const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.h3 `
  color: ${themes.olist.base.color.neutral.stronger};
  font-size: ${themes.olist.base.fontSize['2xlarge']};
  white-space: nowrap;
  margin-bottom: 10px;
`;
const Subtitle = styled.div `
  color: ${themes.olist.base.color.neutral.base};
  font-size: ${themes.olist.base.fontSize['1xsmall']};
  margin-bottom: 36px;

  > * {
    margin: 0;
    text-align: center;
  }
`;

export { Container, Subtitle, Title };
